import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const tabs = css`
  min-inline-size: ${spacing(23.75)}; // 190px
`
